<template>
  <div
    class="page_container userPage"
    v-loading="loading"
    element-loading-text="请稍后"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.5)"
  >
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/mine' }">我的</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: `/companyIndex/userList` }"
          >成员管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{ userInfo.truename }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="form_container">
      <div class="content_wrap flex-between">
        <div class="user_intro">
          <div class="block flex-rowl logo_tit">
            <div class="logo flex-rowc">
              <el-image :src="userInfo.headimg" fit="contain">
                <div slot="error" class="image-slot flex-rowc">
                  <i class="iconfont icon-zanwutupian1"></i>
                </div>
              </el-image>
            </div>
            <div class="content">
             
              <!-- <p>
                ID：
                <span>{{ userInfo.accountid ? userInfo.accountid : "" }}</span>
              </p> -->
            </div>
          </div>
          <div class="block">
             <p>
                昵称：
                <span>{{ userInfo.nickname ? userInfo.nickname : "" }}</span>
              </p>
              <p>
                姓名：
                <span>{{ userInfo.truename ? userInfo.truename : "" }}</span>
              </p>
              <p>
                <span
                  >{{ userInfo.levelid ? "LV-" + userInfo.levelid : "" }} |
                  {{ userInfo.attrname ? userInfo.attrname : "" }}</span
                >
              </p>
            <p>
              工作手机：<span>{{ tuozhan.mobile ? tuozhan.mobile : "" }}</span>
            </p>
            <p>
              工作微信：<span>{{ tuozhan.weixin ? tuozhan.weixin : "" }}</span>
            </p>
            <p>
              性别：<span>{{ userInfo.sex ? userInfo.sex : "" }}</span>
            </p>
            <p>
              年龄：<span>{{ userInfo.age ? userInfo.age : "" }}</span>
            </p>
          </div>
          <div class="block">
            <p>
              所在地区：<span>{{ PCA_address }}</span>
            </p>
            <p>
              详细地址：<span>{{ userInfo.addr }}</span>
            </p>
          </div>
        </div>
        <div class="user_operation flex-cowl">
          <div class="other_wrap" v-if="qy.checkstate == '已通过'">
            <div class="depar_role_wrap">
              <div class="tit">部门及角色设置：</div>
              <div class="from_wrap">
                <el-row :gutter="20">
                  <el-col :span="8">
                    <el-select
                      v-model="department"
                      placeholder="选择部门"
                      @change="changeDeaprt"
                      :disabled="userInfo.rolename == '创建人' ? true : false"
                    >
                      <el-option
                        v-for="item in departList"
                        :key="item.deptid"
                        :label="item.deptname"
                        :value="item.deptid"
                      >
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8">
                    <el-select
                      v-model="role"
                      placeholder="选择角色"
                      @focus="focusGetRole"
                      @change="changeRole"
                      :disabled="userInfo.rolename == '创建人' ? true : false"
                    >
                      <el-option
                        v-for="item in roleList"
                        :key="item.roleid"
                        :label="item.rolename"
                        :value="item.roleid"
                      >
                      </el-option>
                    </el-select>
                  </el-col>
                </el-row>
              </div>
              <div
                class="primary-button"
                @click="handleSubmitDepRole"
                v-if="userInfo.rolename != '创建人'"
              >
                保存
              </div>
            </div>
            <div
              class="primary-button-plain"
              @click="handleRemove"
              v-if="userInfo.rolename != '创建人'"
            >
              移出企业/团队
            </div>
          </div>
          <div class="apply_operation_wrap" v-if="qy.checkstate == '审核中'">
            <div class="content">
              <div class="txt1">申请加入时间：</div>
              <div class="txt2">{{ userInfo.createdate | formatDate }}</div>
            </div>
            <div class="primary-button" @click="handleAgree">同意加入申请</div>
            <div class="primary-button-plain" @click="handleRefuse">
              拒绝加入申请
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getUserInfo, encryptstringview} from "../../api/api";
import {
  refuseApply,
  acceptApply,
  getDeptList,
  getDeptRole,
  setUserDepRole,
  userRemoveCompany,
} from "../../api/company";
export default {
  name: "userDetail",
  data() {
    return {
      loading: false,
      isShow: false,
      department: "",
      departmentId: "",
      departList: [],
      role: "",
      roleId: "",
      roleList: [],
      isShowPopup: false,
      selectType: 1, // 1、部门，2、角色

      PCA_address: "", // 省、市、区
      userInfo: "",
      tuozhan: "",
      works: "",
      qy: "",

      openid: '',
      qyid: '',
      id: ''
    };
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
  },
  created() {
    let { routerList, OPENID} = this.$store.state;
    let { name } = this.$route;
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }

    
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let {openid, qyid, id } = JSON.parse(res.jsondata);
        this.openid = openid
        this.qyid = qyid
        this.id = id
        this.getUserInfo();
        this.getDeptList();
      } else {
        this.$router.back();
      }
    },

    getUserInfo() {
      this.loading = true;
      let { openid } = this;
      getUserInfo({ openid }).then((res) => {
        this.userInfo = res;
        // this.PCA_address = res.provincename
        //   ? res.provincename
        //   : "" + " " + res.cityname
        //   ? res.cityname
        //   : "" + " " + res.areaname
        //   ? res.areaname
        //   : "" + " ";
        this.PCA_address =
          (res.provincename ? res.provincename : "") +
          " " +
          (res.cityname ? res.cityname : "") +
          " " +
          (res.areaname ? res.areaname : "");
        this.tuozhan = res.tuozhan.length == 0 ? "" : res.tuozhan[0];
        this.works = res.works == 0 ? "" : res.works[0];
        this.qy = res.qy;
        this.departmentId = res.deptid;
        this.department = res.deptname;
        this.roleId = res.roleid;
        this.role = res.rolename;
        this.loading = false;
      });
    },

    // 同意
    handleAgree() {
      let { id, qyid } = this;
      acceptApply({ qyid, logid: id }).then((res) => {
        if (res.result) {
          // this.$message.success(res.message);
          this.getUserInfo();
        } else {
          this.$message.error(res.message || "服务器报错，请稍后～");
          this.loading = false;
        }
      });
    },

    // 拒绝
    handleRefuse() {
      let { id, qyid } = this;
      refuseApply({ qyid, logid: id }).then((res) => {
        if (res.result) {
          this.getUserInfo();
        } else {
          this.$message.error(res.message || "服务器报错，请稍后～");
          this.loading = false;
        }
      });
    },

    // 移出企业
    handleRemove() {
      this.$confirm("是否确定移出该成员", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.userRemoveCompany();
        })
        .catch(() => {});
    },
    userRemoveCompany() {
      this.loading = true;
      let { id, qyid } = this;
      userRemoveCompany({ qyid, logid: id }).then((res) => {
        if (res.result) {
          this.loading = false;
          this.$message.success(res.message);
          setTimeout(() => {
            this.$router.back();
          }, 1500);
        } else {
          this.$message.error(res.message || "服务器报错，请稍后～");
          this.loading = false;
        }
      });
    },

    //  获取部门
    getDeptList() {
      getDeptList().then((res) => {
        res.filter((v) => v.deptstate);
        this.departList = res;
      });
    },
    changeDeaprt(e) {
      this.departmentId = e;
    },
    // 获取角色
    focusGetRole() {
      this.roleList = [];
      let { departmentId, roleId } = this;
      if (roleId == 1) {
        return;
      }
      getDeptRole({ deptid: departmentId }).then((res) => {
        let newData = [];
        res.filter((v) => {
          if (v.isuse && v.roleid != 1) {
            newData.push(v);
          }
        });
        this.roleList = newData;
      });
    },
    changeRole(e) {
      this.roleId = e;
    },

    // 管理员对用户进行部门和角色的分配
    handleSubmitDepRole() {
      let { departmentId, roleId, userInfo } = this;

      let params = {
        openid: userInfo.openid,
        deptid: departmentId,
        roleid: roleId,
      };
      this.loading = true;
      setUserDepRole(params).then((res) => {
        if (res.result) {
          this.loading = false;
          let message = this.$message.success(res.message);
          setTimeout(() => {
            message.close();
            this.$router.back();
          }, 1000);
        } else {
          this.$message.error(res.message || "服务器报错，请稍后～");
          this.loading = false;
        }
      });
    },

    // 返回上一页
    handlereturn() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.userPage {
  .user_intro {
    width: 48%;
    flex-shrink: 0;
    margin-right: 5%;
    .block {
      margin-bottom: 25px;
    }
    p {
      color: #404d6c;
    }
    .logo_tit {
      align-items: flex-start;
      .logo {
        width: 100px;
        height: 100px;
        margin-right: 20px;
        background: #fff;
        .icon-zanwutupian1 {
          font-size: 40px;
        }
      }
    }
  }
  .user_operation {
    flex: 1;
    font-size: 18px;
    color: #444;
    .apply_operation_wrap {
      .txt1 {
        margin-bottom: 10px;
      }
      .primary-button {
        margin: 30px 0 20px;
      }
    }
    .other_wrap {
      .depar_role_wrap {
        .tit {
          margin-bottom: 20px;
        }
        .primary-button {
          margin: 30px 0 20px;
        }
        .el-select {
          width: 100%;
        }
      }
    }
  }
}
</style>